import window from 'global';
import { getEnvironmentConstant, stripTrailingSlash } from './utilities';
import { ROUTER_BASENAME } from './constants';

export default ({ env }) => {
  const curPath = stripTrailingSlash(window.location.href);
  if (curPath.includes(`${getEnvironmentConstant({ key: ROUTER_BASENAME, env })}/dashboard`)) {
    return `${window.location.origin }/learn`;
  }
  return window.location.href;
};
